import styled from 'styled-components';

var IconWrapper = styled.span.withConfig({
  displayName: "Iconstyles__IconWrapper",
  componentId: "sc-ukmqn2-0"
})(["display:inline-flex;> svg{color:", ";.secondary-color{color:", ";}}"], function (props) {
  return props.color;
}, function (props) {
  return props.secondaryColor;
});

export { IconWrapper };
//# sourceMappingURL=Icon.styles.js.map
